import React, { useEffect, useRef, useState } from 'react';
import { getFileName, getFileSize, isDocx, isImage, isPdf, isXls } from "../../helpers/media";
import PdfIcon from '../../assets/pdf-icon.svg';
import AttachmentComponentProps from "./AttachmentComponentProps";
import { AttachmentIcon } from './Attachment';

export const PdfComponent: React.FC<AttachmentComponentProps> = ({ media, file_obj, onClick, isReplyMessage }) => {
    if (isReplyMessage) {
        return <div onClick={onClick} className="!w-10 !h-10 mr-2 inline-flex justify-center items-center flex-[0_0_auto]">
            <AttachmentIcon media={media} />
        </div>
    }

    return <div
        onClick={onClick}
        className="
            min-w-24
            max-w-72
            cursor-pointer
            flex flex-row
            justify-start
            items-center
            rounded-md
            overflow-hidden
        "
    >
        <div className="w-14 h-14 flex-[0_0_auto] flex flex-row justify-start items-center  overflow-hidden">
            <img
                alt={media?.original_name || file_obj?.media_info?.original_name}
                src={media?.base64_preview ? `data:image/png;base64,${media.base64_preview}` : file_obj?.media_info.base64_preview ? `data:image/png;base64,${file_obj.media_info.base64_preview}` : PdfIcon}
                className='
                        w-full
                        object-cover
                        font-medium
                        text-blue-400
                        dark:text-blue-500
                        hover:underline'
            />
        </div>
        <div className="
                text-gray-600
                text-[0.8rem]
                p-1
                overflow-hidden
                whitespace-pre-wrap
                break-word-only-long">

            {!isReplyMessage && media && getFileName(media.original_name, 50)}{file_obj && getFileName(file_obj.media_info.original_name, 50)}
            {!isReplyMessage && media && getFileSize(media.size, 6, 2)}{file_obj && getFileSize(file_obj?.media_info.size, 6, 2)}
        </div>
    </div>
}
